<template>
  <DashboardPanel
    :hydrated="hydrated || null"
    :refreshParams="{entityId: visitId}"
    @refreshed="hydrate"
    @removed="emit('removed')"
  >
    <HistoryList :history="history" />
  </DashboardPanel>
</template>
<script setup>
import { ref } from "vue";
import DashboardPanel from "@root/components/DashboardPanel.vue";
import useHydration from "@root/hooks/useHydration";
import HistoryList from "@root/components/HistoryList.vue";

const props = defineProps({
  visitId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['removed']);

const history = ref([]);

const { hydrate, hydrated } = useHydration(({ history: _history }) => {
  history.value = _history;
});


</script>

